import { useState } from "react";
import { Link } from "react-router-dom";
import { lookbookItems } from "@/mocks/testimonials";
import { useScrollAnimation, useStaggerAnimation } from "@/hooks/useScrollAnimation";

const themes = ["通勤氣質穿搭","顯瘦修飾穿搭","熟齡優雅穿搭","約會聚會穿搭","換季推薦穿搭"];

export default function LookbookSection() {
  const [activeTheme, setActiveTheme] = useState(0);
  const headerAnim = useScrollAnimation();
  const cardsAnim = useStaggerAnimation(lookbookItems.length, { threshold: 0.05 });

  return (
    <section className="bg-[#f0e8df] py-20 md:py-28 overflow-hidden">
      <div className="w-full px-6 md:px-16 max-w-[1400px] mx-auto">
        {/* Title */}
        <div
          ref={headerAnim.ref as React.RefObject<HTMLDivElement>}
          className={`text-center mb-12 transition-all duration-700 ${headerAnim.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <p className="text-[#8B5E52] text-[1rem] tracking-[0.25em] uppercase font-medium mb-3">Style Guide</p>
          <h2 className="text-[#3d2b1f] text-[2.125rem] md:text-[2.5rem] font-bold leading-[1.4]">穿搭提案</h2>
          <p className="text-[#7a6455] text-[1.1875rem] mt-4 max-w-lg mx-auto leading-[1.75]">不只是賣衣服，更是你的穿搭靈感夥伴，讓每天的穿著都充滿自信與品味。</p>
        </div>

        {/* Theme Tags */}
        <div className={`flex flex-wrap items-center justify-center gap-3 mb-12 transition-all duration-700 delay-200 ${headerAnim.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {themes.map((t, i) => (
            <button
              key={i}
              onClick={() => setActiveTheme(i)}
              className={`px-5 py-2 rounded-full text-[1rem] font-medium cursor-pointer transition-all duration-200 whitespace-nowrap ${i === activeTheme ? "bg-[#3d2b1f] text-[#faf8f5]" : "bg-white text-[#7a6455] hover:bg-[#3d2b1f] hover:text-[#faf8f5]"}`}
            >
              {t}
            </button>
          ))}
        </div>

        {/* Cards */}
        <div
          ref={cardsAnim.ref as React.RefObject<HTMLDivElement>}
          className="grid grid-cols-1 md:grid-cols-3 gap-6"
        >
          {lookbookItems.map((item, i) => (
            <div
              key={item.id}
              className={`group relative rounded-lg overflow-hidden cursor-pointer aspect-[4/5] transition-all duration-700 ${cardsAnim.visibleItems[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}
            >
              <img src={item.image} alt={item.title} className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#3d2b1f]/80 via-[#3d2b1f]/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6 text-center translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                <h3 className="text-white text-[1.25rem] font-bold mb-1">{item.title}</h3>
                <p className="text-white/80 text-[1rem] mb-4">{item.subtitle}</p>
                <Link to="/lookbook" className="inline-flex items-center gap-1.5 px-5 py-2 bg-white/20 backdrop-blur-sm border border-white/40 text-white rounded-full text-[0.9375rem] hover:bg-white/35 transition-colors cursor-pointer whitespace-nowrap">
                  查看穿搭提案 <i className="ri-arrow-right-line text-sm"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className={`text-center mt-10 transition-all duration-700 delay-300 ${cardsAnim.visibleItems[2] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <Link to="/lookbook" className="inline-flex items-center gap-2 px-8 py-3.5 bg-[#3d2b1f] text-[#faf8f5] rounded-full text-[1.0625rem] font-semibold hover:bg-[#8B5E52] transition-colors cursor-pointer whitespace-nowrap">
            探索更多穿搭提案 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
